import React, { createContext, useContext } from 'react';
import { useVoiceDetection } from '../hooks/useVoiceDetection';

interface VoiceContextType {
  isListening: boolean;
  voiceLevel: number;
  error: string | null;
  transcript: string;
  startListening: () => Promise<void>;
  stopListening: () => void;
}

const VoiceContext = createContext<VoiceContextType | undefined>(undefined);

export const VoiceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const voiceDetection = useVoiceDetection();
  
  return (
    <VoiceContext.Provider value={voiceDetection}>
      {children}
    </VoiceContext.Provider>
  );
};

export const useVoiceContext = () => {
  const context = useContext(VoiceContext);
  if (context === undefined) {
    throw new Error('useVoiceContext must be used within a VoiceProvider');
  }
  return context;
};
